import React, { useState } from "react";
import MoreAftercare from "./MoreAftercare";

function Aftercare() {

  // Example data for days
  const days = [
    {
      title: "Day 1",
      content:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Exercitationem velit dolores ratione esse deserunt sapiente doloremque repudiandae minus officia assumenda possimus ullam blanditiis alias mollitia, illo tenetur magnam rem! Ducimus!",
    },
    {
      title: "Day 2-3",
      content:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Exercitationem velit dolores ratione esse deserunt sapiente doloremque repudiandae minus officia assumenda possimus ullam blanditiis alias mollitia, illo tenetur magnam rem! Ducimus!",
    },
    {
      title: "Day 4-6",
      content:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Exercitationem velit dolores ratione esse deserunt sapiente doloremque repudiandae minus officia assumenda possimus ullam blanditiis alias mollitia, illo tenetur magnam rem! Ducimus!",
    },
    {
      title: "Day 15-30",
      content:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Exercitationem velit dolores ratione esse deserunt sapiente doloremque repudiandae minus officia assumenda possimus ullam blanditiis alias mollitia, illo tenetur magnam rem! Ducimus!",
    },
  ];

  const [showMore, setShowMore] = useState(false);

  const handleButtonClick = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      <section className="mx-4 mt-[8rem] gallery relative mb-16">
        <h1 className="text-[5rem] md:text-[11rem] opacity-10 font-bold hidden md:block absolute top-[-2.5rem]">
          aftercare
        </h1>
        <h2 className="text-[2.5rem] md:pt-[8rem] md:pl-[20rem] border-b border-white mr-[6rem] pl-6 md:border-none mb-10">
          healing & shit
        </h2>

        <div className="grid lg:grid-cols-2 gap-6 lg:mx-12 2xl:mx-[8rem]">
          {days.map((day, index) => (
            <div key={index} className="border border-[#7d7d7d] p-4 rounded-md">
              <h2 className="text-[#facc9e]">{day.title}</h2>
              <p>{day.content}</p>
            </div>
          ))}
        </div>

        {/* Renders the button only if showMore state is false */}
        {!showMore && (
          <button className="flex m-auto my-10 hover:tracking-widest hover:text-[#ff4e00] hover:duration-300 hover:border-b" onClick={handleButtonClick}>
            Read more tips
          </button>
        )}

        {/* Render MoreAftercare component if showMore state is true  */}
        {showMore && <MoreAftercare />}

        {/* Render a button to toggle showMore state back to false */}
        {showMore && (
          <button className="flex m-auto my-10 hover:tracking-widest hover:text-[#ff4e00] hover:duration-300 hover:border-b" onClick={handleButtonClick}>
            Read less
          </button>
        )}
      </section>
    </>
  );
}

export default Aftercare;
